import React from 'react'
import { useParams } from 'react-router-dom'
import { PayrollPaymentDashboard } from './PayrollPaymentDashboard'

export const PayrollPaymentView: React.FC = () => {
  const params = useParams<{ id: string }>()
  const paymentId = Number(params.id ?? 0)

  return (
    <PayrollPaymentDashboard
      initialPaymentId={Number.isFinite(paymentId) && paymentId > 0 ? paymentId : undefined}
      showBackButton
    />
  )
}
